import "@/client/styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/client/app";

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root element");

createRoot(root, {
  // React empties the page after an error no boundary caught; the start icon would read as loading.
  onUncaughtError: (error) => {
    document.getElementById("boot")?.remove();
    reportError(error);
  },
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
